/**
  Load levels that a domain object can have.
*/

  // Meaning object has not been loaded from persistent store
export const NONE=0;
  // Meaning that the only piece of data on the object is it's persistent id
export const ID=1;
  // Meaning that enough data is loaded for the object to show it in a list
export const LIST=2;
  // Meaning that enough data is loaded to show a detail-page for the object
export const DETAIL=3;
  // If a full set of related data etc. has been loaded in order be be able
  // to present a report on this entity, we may set the load level to :
export const REPORT=4;



/** WEBPACK FOOTER **
 ** ./src/DataModel/LoadLevel.js
 **/